(function ($) {
    $.nette.ext('extra-services', {
        init() {
            const self = this;

            this.ext('snippets', true).before($.proxy(() => {
            }, this));

            this.ext('snippets', true).after($.proxy(($el) => {
                self.hideButton($el);
                self.initForm($el);
            }, this));

            const $body = $('body');
            self.hideButton($body);
            self.initForm($body);
        },
    }, {
        hideButton($el) {
            $el.find('form.extra-services button[name="calculate"]').hide();
        },
        initForm($el) {
            const $form = $el.find('form.extra-services');
            const $button = $el.find('form.extra-services button[name="calculate"]');

            $form.find('[type="checkbox"], [type="radio"]').on('change', () => {
                $button.click();
            });
        },
    });
}(jQuery));
